// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyBkEcvYWbklQ3fEBxn9O56adBIyOFuvE7c",
    authDomain: "ez-calc.firebaseapp.com",
    projectId: "ez-calc",
    storageBucket: "ez-calc.appspot.com",
    messagingSenderId: "175145251503",
    appId: "1:175145251503:web:6eed57d102e0b85d0b9a5a",
    measurementId: "G-BDFDZLYP15"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
